<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Résultat de recherche</strong>
      </b-card-header>
      <b-card-body>
        <b-row v-if="beneficiaire" class="mb-4">
          <b-col>
            <span>1 bénéficiaire trouvé</span><br>
            <a href="#" @click.prevent="ficheBeneficiaire(beneficiaire.id)">
              {{ beneficiaire.nom }} {{beneficiaire.prenom }}</a>
          </b-col>
        </b-row>
        <b-row v-if="assure" class="mb-4">
          <b-col>
            <span>1 assuré trouvé</span><br>
            <a href="#" @click.prevent="ficheAssure(assure.nir)">
              {{ assure.nom }} {{assure.prenom }}
            </a>
          </b-col>
        </b-row>
        <b-row v-if="dossiers.length > 0" class="mb-4">
          <b-col>
            <span> {{ dossiers.length}} dossier(s) trouvé(s) : </span>
            <div v-for="(dossiers,key) in formattedDossiers" :key="key">
              <a class="ml-2" href="#" @click.prevent="rechercheDossier(dossiers[0])">
                {{ dossiers.length }} {{ key }}
              </a>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {isEmpty} from "@/utils/fileHelper";
  import {getMainTreatmentBasedOnType} from "@/utils/communHelper";

  export default {
    name: "RechercheParNir",
    data() {
      return {
        nir: '',
        assure: null,
        beneficiaire: null,
        sirens: [],
        dossiers: [],
        allTraitements: [],
        formattedDossiers: [],
        dossiersReady: false,
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getAllTraitements();
      this.searchNir(this.$route.params.nir);
    },
    mounted(){
      this.$route.meta.cssClass = this.$route.query.cssClass;
      this.$route.meta.site = this.$route.query.site;
    },
    watch: {
      '$route.params.nir'(nir) {
        this.searchNir(nir);
      }
    },
    methods: {
      searchNir(nir) {
        this.resetData();
        this.nir = nir;
        this.$axios
          .get('/recherche/globale/' + nir)
          .then(response => {
            this.sirens = response.data.data.assure;
            this.beneficiaire = response.data.data.beneficiaire;
            this.formatDossiers(response.data.data.dossiers);
            if (this.sirens.length > 0) {
              this.assure = this.sirens[0];
            }
          })
          .catch((error) => {
            console.log(error)
          });
      },
      ficheSiren(siren, raison_sociale) {
        window.open(`/espace-gestion/sirens/fiche/${siren}?rs=${raison_sociale}`, '_blank');
      },
      ficheBeneficiaire(beneficiaireId) {
        window.open(`/espace-beneficiaire/beneficiaires/fiche/${beneficiaireId}`, '_blank');
      },
      ficheAssure(assureNir) {
        window.open(`/espace-gestion/assures/fiche/${assureNir}`, '_blank');
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      resetData() {
        this.assure = null;
        this.beneficiaire = null;
        this.sirens = [];
      },
      formatDossiers(dossiers) {
        this.dossiers = dossiers.map( dossier => {
          dossier.idTraitement = this.getTraitementId(dossier);
          return dossier;
        });
        this.formattedDossiers = _.groupBy(this.dossiers, 'type.groupe')
      },
      getTraitementId(dossier) {
        let traitementId = '';
        if (!isEmpty(dossier.traitement_id)) {
          traitementId = dossier.traitement_id;
        } else {
          traitementId = this.getDossierTypeTraitement(dossier);
        }
        return traitementId;
      },
      getDossierTypeTraitement(dossier) {
        let traitementId = '';
        let mainTreatment = getMainTreatmentBasedOnType(dossier, this.allTraitements);
        
        traitementId = mainTreatment.id;
        return traitementId;
      },
      getAllTraitements() {
        this.$axios
          .get("/administration/traitements")
          .then(response => {
            this.allTraitements = response.data.traitements;
          });
      },
      rechercheDossier(dossier) {
        // window.open(`/espace-gestion/dossier/dashboard?nir=${dossier.nir}&traitementId=${dossier.idTraitement}&page=1&limit=10&modeVisualisation=monActiviteProd`, '_blank');
        window.open(`/espace-gestion/dossier/dashboard?nir=${dossier.nir}&onlyOneCritere=nir&page=1&limit=10&modeVisualisation=monActiviteProd`, '_blank');
      }
    }
  }
</script>
